/* global axios */
import ApiClient from './ApiClient';

class SupportTicketsAPI extends ApiClient {
  constructor() {
    super('support_tickets', { accountScoped: true });
  }

  get(params = {}) {
    // 支持分页、搜索和筛选参数
    return axios.get(this.url, { params });
  }

  create(data) {
    // 包装数据在 support_ticket 键中，符合 Rails 强参数约定
    return axios.post(this.url, { support_ticket: data });
  }

  close(ticketId) {
    return axios.post(`${this.url}/${ticketId}/close`);
  }

  urge(ticketId) {
    return axios.post(`${this.url}/${ticketId}/urge`);
  }

  sendMessage(ticketId, messageData) {
    return axios.post(`${this.url}/${ticketId}/messages`, {
      message: messageData,
    });
  }
}

export default new SupportTicketsAPI();
